import { getTimeString, TimeMode } from "@opendash/core";
import { ColumnProps } from "antd/es/table";
import React from "react";
import { Order } from "../types";
import { ActiveOrderFieldColumn } from "./MESOrderFields/ActiveOrderColumn";
import OrderCompleteField from "./MESOrderFields/OrderCompleteField";
import StatusTag from "./MESOrderFields/StatusTag";
const durationRenderFunction = (order: Order) =>
  OrderCompleteField({
    value: order?.get("duration") || 0,
    fieldname: "duration",
    parseObject: order,
    props: { unit: "ms", value: order?.get("duration") || 0 },
  });
const order_quantityRenderFunction = (order: Order) => (
  <span>{order?.get("order_quantity") || "-"}</span>
);
const statusRenderFunction = (order: Order) => (
  <span>{order?.get("status") || "-"}</span>
);
export const CustomMesOrderCols: ColumnProps<any>[] = [
  {
    title: "openware:admin.classes.OD3_MES_OrderPlan.fields.createdAt",
    align: "center",
    //@ts-expect-error
    children: [
      {
        title: "openware:admin.classes.OD3_MES_Order.fields.duration",
        align: "center",
        dataIndex: "order_quantity",
        key: "current.order_quantity",
        render: (value, record, index) => {
          return (
            <ActiveOrderFieldColumn
              orderPlanNr={record.get("ordernr")}
              render={durationRenderFunction}
            />
          );
        },
      },

      {
        title: "openware:admin.classes.OD3_MES_Order.fields.order_quantity",
        align: "center",
        dataIndex: "order_quantity",
        key: "current.order_quantity",
        render: (value, record, index) => {
          return (
            <ActiveOrderFieldColumn
              orderPlanNr={record.get("ordernr")}
              render={order_quantityRenderFunction}
            />
          );
        },
      },
      {
        title: "openware:admin.classes.OD3_MES_Order.fields.status",
        align: "center",
        dataIndex: "order_quantity",
        key: "current.order_quantity",
        render: (value, record, index) => {
          return (
            <ActiveOrderFieldColumn
              orderPlanNr={record.get("ordernr")}
              render={(order: Order) => {
                return <StatusTag status={order?.get("status")} />;
              }}
            />
          );
        },
      },
      {
        title: "openware:admin.classes.OD3_MES_Order.fields.targettime",
        align: "center",
        dataIndex: "targettime",
        key: "current.targettime",
        render: (value, record, index) => {
          return (
            <ActiveOrderFieldColumn
              orderPlanNr={record.get("ordernr")}
              render={(order: Order) => (
                <span>
                  {order?.get("targettime")
                    ? getTimeString(
                        TimeMode.DurationMode,
                        "full",
                        "ms",
                        order.get("targettime")
                      )
                    : "-"}
                </span>
              )}
            />
          );
        },
      },
      {
        title: "openware:admin.classes.OD3_MES_Order.fields.source",
        align: "center",
        dataIndex: "source",
        key: "current.source",
        render: (value, record, index) => {
          return (
            <ActiveOrderFieldColumn
              orderPlanNr={record.get("ordernr")}
              render={(order: Order) => (
                <span>{order?.get("source").get("name")}</span>
              )}
            />
          );
        },
      },
    ],
  },
];
